import React, { Component } from "react";
import { Row, Col, Button, Modal, Typography, Form, Input, message, Spin, InputNumber } from 'antd';
import SelectUsuario from "../../../Widgets/Inputs/SelectUsuarios";

const { Title } = Typography;
const axios = require('axios').default;


/**
 * @class ModalCentrosCostos
 * @extends {Component}
 */
class ModalCentrosCostos  extends Component {

    constructor(props) {
        super(props);
        this.state = {
            accionModal: '',
            loading: false,
            datosConsultados: false,
            return: false,
            tipo: 1,
        }
    }

    ModalCentrosCostos = React.createRef();

    componentDidMount() {
        axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token');
        if (this.props.centro_costo_id !== undefined) {
            this.getCentroCosto()
        }
    }


    /**
     * @memberof ModalCentrosCostos
     * @method onFinish
     * @description Se ejecuta al dar enter al formulario
     */
    onFinish = (values) => {
        if (this.props.centro_costo_id) {
            this.updateCentro(values)
        } else {
            this.addCentro(values)
        }
    }


    /**
     * @memberof ModalCentrosCostos
     * @method addCentro
     * @description Añade un nuevo centro de costo relacionado al cliente en la BD
     */
    addCentro = (values) => {
        this.setState({loading: true})
        axios.post('/centros', {
            ...values,
            cliente_id: this.props.cliente_id
        }).then(() => {
            message.success('Centro de Costo creado')
            this.props.onClose()
            
        }).catch(error => {
            console.log(error)
            message.error(error?.response?.data?.message ?? 'Error al crear Centro de Costo.')
        })
        .finally(() => {
            this.setState({loading: false})
        })


    }


    /**
     * @memberof ModalCentrosCostos
     * @method getCentroCosto
     * @description Obtiene un Centro de Costo de la DB
     */
    getCentroCosto = () => {
        this.setState({ loading: true })
        axios.get('/centros/'+this.props.centro_costo_id)
        .then(response => {
            this.ModalCentrosCostos.current.setFieldsValue({
                ...response.data
            })

        }).catch(error => {
            message.error(error?.response?.data?.message ?? 'Error al traer el Centro de Costo')
            console.log(error)
        }).finally(() => this.setState({ loading: false }))
    }



    /**
     * @memberof ModalCentrosCostos
     * @method updateCentro
     * @description Actualiza la información de un centro de Control
     */
    updateCentro = (values) => {
        this.setState({ loading: true })
        axios.put('/centros', {
            ...values,
            centro_costo_id: this.props.centro_costo_id,
        }).then(response => {
            message.success('Centro de Costo actualizado')
            this.props.onClose()
        }).catch(error => {
            message.error(error?.response?.data?.message ?? 'Error al actualizar el Centro de Costo')
            console.log(error)
        }).finally(() => this.setState({ loading: false }))
    }


    render() {
        return (
            <Form
                layout="vertical"
                name="form-materiales"
                ref={this.ModalCentrosCostos}
                onFinish={this.onFinish}

            >
                <Spin spinning={this.state.loading}>
                    <Row className="ant-row-center">
                        <Col xs={24} lg={20} >
                            <Form.Item
                                label="Nombre"
                                name="nombre"
                                rules={[{
                                    required: true,
                                    message: "Por favor, ingrese el nombre"
                                }]}
                            >
                                <Input placeholder="Nombre" ></Input>
                            </Form.Item>
                        </Col>
                        <Col xs={24} lg={20} >
                            <Form.Item
                                label="Descripción"
                                name="descripcion"
                            >
                                <Input placeholder="Descripción" ></Input>
                            </Form.Item>
                        </Col>
                        <Col xs={24} lg={20} >
                            <Form.Item
                                label="Limite"
                                name="limite"
                            >
                                <InputNumber
                                    className="width-100"
                                    placeholder="Limite"
                                    min={0}
                                    formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24} lg={20} >
                            <Form.Item
                                label="Usuarios"
                                name="usuarios"
                            >
                                <SelectUsuario
                                    params={{ cliente_id: this.props.cliente_id }}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row >
                        <Col span={24} className="text-center">
                            <Form.Item >
                                <Button htmlType="submit" type="primary" loading={this.state.loading}>
                                    Guardar
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Spin>
            </Form>
        )
    }
}



export default function (props) {
    const { visible = false, onClose = () => { } } = props

    return <Modal
        open={visible}
        onCancel={onClose}
        title={null}
        footer={null}
        closable={true}
        destroyOnClose={true}
        zIndex={1000}
    >
        <div className="center">
            <Title level={3}>  Centros de Costos</Title>
        </div>
        <ModalCentrosCostos {...props} />
    </Modal>

}